module.exports = __webpack_public_path__ + "static/media/Product Logos-121.09d6b67f.svg";